import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

import { DEFAULT_STALE_TIME } from '@/shared/config'
import { registerReset } from '@/shared/lib/reset-registry'

import { reportRequestError } from '@/features/auth'

/**
 * Created once at module scope. Constructing a QueryClient inside a component
 * throws the whole cache away on every render.
 */
export const queryClient = new QueryClient({
  // `throwOnError: false` keeps failures out of the ErrorBoundary, but they
  // still reach the caches — the one place that sees every request in the app,
  // which is where a revoked account has to be noticed.
  queryCache: new QueryCache({ onError: reportRequestError }),
  mutationCache: new MutationCache({ onError: reportRequestError }),
  defaultOptions: {
    queries: {
      staleTime: DEFAULT_STALE_TIME,
      // Transport-level retries already happen in `shared/api` (GET only, 5xx
      // and network failures, never a 4xx). Retrying again here would multiply
      // the attempts and re-run failed schema parses that can never succeed.
      retry: false,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      // A routine network failure must render an error block, not tear the
      // screen down through the route's ErrorBoundary.
      throwOnError: false,
    },
    mutations: {
      retry: false,
    },
  },
})

registerReset(() => {
  queryClient.cancelQueries()
  queryClient.clear()
})
